import React from 'react';
import PropTypes from 'prop-types'

const Switch = (
  {
    onChange,
    checked = false,
    labelOff,
    labelOn,
    labelTextClassName = '',
    disabled = false,
    inputRef,
    ...inputProps
  }) => {
  const [isChecked, setChecked] = React.useState(checked)

  const handleChange = (e) => {
    const state = e.currentTarget.checked
    setChecked(state)
    if(typeof onChange === 'function') {
      onChange(state)
    }
  }
  return (

    <label className='form-check form-switch form-check-custom form-check-solid'>
      <span className='form-check-label switch-label-off fw-bold'>
       {labelOff}
      </span>
      <input
        ref={inputRef}
        onChange={handleChange}
        className='form-check-input'
        type='checkbox'
        value=""
        checked={isChecked}
        disabled={disabled}
        {...inputProps}
      />
      <span className='form-check-label switch-label-on fw-bold'>
       {labelOn}
      </span>
    </label>
  )
}

Switch.defaultProps = {
  onChange: () => {},
  inputRef: React.createRef()
}

Switch.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  labelOff: PropTypes.string,
  labelOn: PropTypes.string,
  labelTextClassName: PropTypes.string,
}

export default Switch;
